import React, { useEffect, useState } from 'react';
import { useAd } from '../context/AdContext';
import { Spinner } from './UI';

const SKIP_DELAY_MS = 5000;

export default function AdOverlay() {
    const { current, visible, dismissAd, clickAd } = useAd();
    const [canSkip, setCanSkip] = useState(false);
    const [countdown, setCountdown] = useState(0);

    useEffect(() => {
        if (!visible || !current) { setCanSkip(false); return; }
        const delay = current.skipAfterMs ?? SKIP_DELAY_MS;
        setCountdown(Math.ceil(delay / 1000));
        setCanSkip(false);
        const iv = setInterval(() => {
            setCountdown(c => {
                if (c <= 1) { clearInterval(iv); setCanSkip(true); return 0; }
                return c - 1;
            });
        }, 1000);
        return () => clearInterval(iv);
    }, [visible, current]);

    const handleClick = () => {
        clickAd();
        if (current?.linkUrl) window.open(current.linkUrl, '_blank');
        dismissAd(false);
    };

    if (!visible || !current) return null;

    return (
        <div style={{
            position: 'fixed', inset: 0, zIndex: 2000,
            backgroundColor: 'rgba(5,46,22,0.92)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24,
        }}>
            <div style={{
                backgroundColor: 'var(--bg-card)', borderRadius: 20, overflow: 'hidden',
                border: '1px solid var(--border)', width: '100%', maxWidth: 440,
                animation: 'slideUp 0.3s ease',
            }}>
                {/* Header */}
                <div style={{ display: 'flex', alignItems: 'center', padding: '12px 16px', gap: 8 }}>
                    <span style={{
                        backgroundColor: 'var(--bg-surface)', padding: '2px 8px',
                        borderRadius: 4, color: 'var(--text-muted)', fontSize: 11, fontWeight: 700
                    }}>AD</span>
                    <span style={{
                        flex: 1, color: 'var(--text-primary)', fontSize: 15, fontWeight: 600,
                        overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'
                    }}>
                        {current.title}
                    </span>
                    {canSkip ? (
                        <button onClick={() => dismissAd(true)} style={{
                            backgroundColor: 'var(--bg-surface)', border: 'none', color: 'var(--brand-300)',
                            fontSize: 13, fontWeight: 700, padding: '4px 10px', borderRadius: 8, cursor: 'pointer',
                        }}>Skip ✕</button>
                    ) : (
                        <span style={{
                            backgroundColor: 'var(--bg-surface)', padding: '4px 10px',
                            borderRadius: 8, color: 'var(--text-muted)', fontSize: 13
                        }}>{countdown}s</span>
                    )}
                </div>

                {/* Media */}
                <div onClick={handleClick} style={{
                    cursor: 'pointer', height: 240, overflow: 'hidden',
                    backgroundColor: 'var(--bg-surface)', display: 'flex', alignItems: 'center', justifyContent: 'center'
                }}>
                    {current.mediaUrl
                        ? <img src={current.mediaUrl} alt={current.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                        : <Spinner size={32} />
                    }
                </div>

                {/* Footer */}
                <div style={{ padding: '8px 16px' }}>
                    <p style={{ color: 'var(--text-muted)', fontSize: 13 }}>{current.companyName}</p>
                </div>
                {current.linkUrl && (
                    <div style={{ padding: '0 16px 16px' }}>
                        <button onClick={handleClick} style={{
                            width: '100%', backgroundColor: 'var(--brand-500)', color: '#fff',
                            border: 'none', borderRadius: 10, padding: '12px', fontSize: 15,
                            fontWeight: 700, cursor: 'pointer',
                        }}>Learn More →</button>
                    </div>
                )}
            </div>
        </div>
    );
}
